<div class="chart-container" role="img" [attr.aria-label]="chartName + ' bar chart'">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [dataLabels]="chartOptions.dataLabels"
    [plotOptions]="chartOptions.plotOptions"
    [title]="chartOptions.title"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis"
  >
  </apx-chart>
</div>
